import scanApi from '@/domains/scan/api/scan.api';
import ScanOptionEnum from '@/domains/scan/typescript/enums/ScanOptionEnum';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import type DeviceInterface from '@/domains/scan/typescript/interfaces/DeviceInterface';

export default defineStore('scan', () => {
    const isSoleComputing = ref(false);

    const loaderMessage = ref<string>();

    const selected3DItemId = ref<number>(-1);

    // Manage scan hash

    const scanHash = ref<string>();
    const lastComputeScanHash = ref<string>();

    const isScanDigestEnabled = ref<boolean>(true);

    // Set when an order's sceneFile could not be loaded, so a later save leaves the stored file
    // alone instead of overwriting a valid scan with the default meshes.
    const hasSceneLoadFailed = ref<boolean>(false);

    const deviceList = ref<DeviceInterface[]>([]);
    const selectedScanOption = ref(ScanOptionEnum.Positive);

    async function fetchDevices() {
        deviceList.value = await scanApi.getListDevices();
    }

    function $reset() {
        console.info('reset scan store');
        selected3DItemId.value = -1;

        scanHash.value = undefined;
        lastComputeScanHash.value = undefined;
        isScanDigestEnabled.value = true;
        hasSceneLoadFailed.value = false;
        loaderMessage.value = undefined;
        selectedScanOption.value = ScanOptionEnum.Positive;
        isSoleComputing.value = false;
        // deviceList stays: the Podonex peripherals are scoped to the workstation, not to whoever
        // is logged in, and fetchDevices() is only called from the scanner screen.
    }

    return {
        loaderMessage,
        scanHash,
        lastComputeScanHash,
        isScanDigestEnabled,
        hasSceneLoadFailed,
        isSoleComputing,
        deviceList,
        selectedScanOption,
        fetchDevices,
        $reset,
    };
});
